import type { OrderStatus } from '@thinkalpha/trading-ws-client/contracts/order.js';
import type { BlotterDisplayStatus } from '@thinkalpha/ui-types/contracts/workspace';
import { getOrderStatusValues } from 'src/lib/orders/getOrderStatusValues';

export const blotterOrderStatuses: BlotterDisplayStatus[] = [...getOrderStatusValues(), 'done-for-day'];
export const messagesOrderStatuses = getOrderStatusValues().filter((status) => status !== 'expired');

/** Ignore unsupported saved selections while retaining any selected message statuses. */
export function normalizeMessagesStatusFilter(
    statuses: readonly BlotterDisplayStatus[] | null | undefined,
): OrderStatus[] | null {
    if (!statuses) return null;
    const supported = statuses.filter((status): status is Exclude<OrderStatus, 'expired'> =>
        messagesOrderStatuses.some((option) => option === status),
    );
    return supported.length ? supported : null;
}
